import { FEATURE_FLAGS } from "@cede/types";
import { CEDE_CEXS } from "@cede/utils";
import { useOAuthSupportMap } from "./useOAuthSupportMap";
import { useFeatureFlagIsOn } from "@/hooks/feature-flags";

const CEX_FEATURE_FLAG_MAP = {
  [CEDE_CEXS.BYBIT]: FEATURE_FLAGS.API_KEYS_HUB_BYBIT,
  [CEDE_CEXS.BITGET]: FEATURE_FLAGS.API_KEYS_HUB_BITGET,
  [CEDE_CEXS.KUCOIN]: FEATURE_FLAGS.API_KEYS_HUB_KUCOIN,
  [CEDE_CEXS.MEXC]: FEATURE_FLAGS.API_KEYS_HUB_MEXC,
  [CEDE_CEXS.BINANCE]: FEATURE_FLAGS.API_KEYS_HUB_BINANCE,
  [CEDE_CEXS.GATEIO]: FEATURE_FLAGS.API_KEYS_HUB_GATEIO,
  [CEDE_CEXS.CRYPTOCOM]: FEATURE_FLAGS.API_KEYS_HUB_CRYPTOCOM,
  [CEDE_CEXS.KRAKEN]: FEATURE_FLAGS.API_KEYS_HUB_KRAKEN,
} as const;

export const useApiKeysSupportMap = () => {
  const oauthSupportMap = useOAuthSupportMap();
  const map = {} as Record<string, boolean>;
  for (const cex in CEX_FEATURE_FLAG_MAP) {
    if (!CEX_FEATURE_FLAG_MAP[cex]) continue;
    map[cex] = useFeatureFlagIsOn(CEX_FEATURE_FLAG_MAP[cex]);

    if (!map[cex] && !oauthSupportMap[cex]) {
      map[cex] = true; // If the exchange is neither supported by API keys nor OAuth, we will enforce the use of API keys
    }
  }
  return map;
};
